module.exports = {
	"levels": [
		{
			"name": "Hello Challenge",
			"created": "2019-09-20",
			"difficulty": "1",
			"description": "instances.md",
			"completedDescription": "instances_complete.md",
			"levelContract": "InstanceFactory.sol",
			"instanceContract": "Instance.sol",
			"revealCode": false,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "0",
			"instanceGas": 800000,
			"author": "Alejandro"
		},
		{
			"name": "Bank",
			"created": "2019-09-20",
			"difficulty": "2",
			"description": "bank.md",
			"completedDescription": "bank_complete.md",
			"levelContract": "BankFactory.sol",
			"instanceContract": "Bank.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "1",
			"instanceGas": 400000,
			"author": "Bill Hsu"
		},
		{
			"name": "Encrypt",
			"created": "2019-09-25",
			"difficulty": "2",
			"description": "encrypt.md",
			"completedDescription": "encrypt_complete.md",
			"levelContract": "EncryptFactory.sol",
			"instanceContract": "Encrypt.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "2",
			"instanceGas": 300000,
			"author": "Bill Hsu"
		},
		{
			"name": "Freeshop",
			"created": "2019-09-26",
			"difficulty": "3",
			"description": "freeshop.md",
			"completedDescription": "freeshop_complete.md",
			"levelContract": "FreeshopFactory.sol",
			"instanceContract": "Freeshop.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 1,
			"deployId": "3",
			"instanceGas": 400000,
			"author": "anonymous"
		},
		{
			"name": "University",
			"created": "2019-09-27",
			"difficulty": "3",
			"description": "university.md",
			"completedDescription": "university_complete.md",
			"levelContract": "UniversityFactory.sol",
			"instanceContract": "University.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "4",
			"instanceGas": 800000,
			"author": "BoYu Chen"
		},
		{
			"name": "Fake Fibonacci",
			"created": "2019-09-27",
			"difficulty": "6",
			"description": "fakeFibonacci.md",
			"completedDescription": "fakeFibonacci_complete.md",
			"levelContract": "FakeFibonacciFactory.sol",
			"instanceContract": "FakeFibonacciBank.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 1,
			"deployId": "5",
			"instanceGas": 800000,
			"author": "Bill Hsu"
		},
		{
			"name": "PaperScissorsStone",
			"created": "2019-09-29",
			"difficulty": "4",
			"description": "paperScissorsStone.md",
			"completedDescription": "paperScissorsStone_complete.md",
			"levelContract": "PaperScissorsStoneFactory.sol",
			"instanceContract": "PaperScissorsStone.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "6",
			"instanceGas": 400000,
			"author": "BoYu Chen"
		},
		{
			"name": "Fomo4D",
			"created": "2019-09-29",
			"difficulty": "4",
			"description": "Fomo4D.md",
			"completedDescription": "Fomo4D_complete.md",
			"levelContract": "Fomo4DFactory.sol",
			"instanceContract": "Fomo4D.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "7",
			"instanceGas": 400000,
			"author": "BoYu Chen"
		},
		{
			"name": "MorganStark",
			"created": "2019-09-30",
			"difficulty": "5",
			"description": "MorganStark.md",
			"completedDescription": "MorganStark_complete.md",
			"levelContract": "MorganStarkFactory.sol",
			"instanceContract": "MorganStark.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "8",
			"instanceGas": 300000,
			"author": "Jack Tseng"
		},
		{
			"name": "Venture Capital",
			"created": "2019-09-30",
			"difficulty": "8",
			"description": "ventureCapital.md",
			"completedDescription": "ventureCapital_complete.md",
			"levelContract": "VentureCapitalFactory.sol",
			"instanceContract": "VentureCapital.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 1,
			"deployId": "9",
			"instanceGas": 900000,
			"author": "Bill Hsu"
		},
		{
			"name": "Strong Box",
			"created": "2019-10-07",
			"difficulty": "8",
			"description": "strongBox.md",
			"completedDescription": "strongBox_complete.md",
			"levelContract": "StrongBoxFactory.sol",
			"instanceContract": "StrongBox.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "10",
			"instanceGas": 900000,
			"author": "Bill Hsu"
		},
		{
			"name": "Dragon",
			"created": "2019-10-10",
			"difficulty": "8",
			"description": "dragon.md",
			"completedDescription": "dragon_complete.md",
			"levelContract": "DragonFactory.sol",
			"instanceContract": "Dragon.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "11",
			"instanceGas": 900000,
			"author": "BoYu Chen"
		},
		{
			"name": "Crosslink Ship",
			"created": "2019-10-13",
			"difficulty": "8",
			"description": "crosslinkShip.md",
			"completedDescription": "crosslinkShip_complete.md",
			"levelContract": "CrosslinkShipFactory.sol",
			"instanceContract": "CrosslinkShip.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "12",
			"instanceGas": 900000,
			"author": "Bill Hsu"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/gamedata.json
// module id = 1060
// module chunks = 0